import { Languages } from '../interfaces/common'

export interface IUzGetPageRenderResponseTextParam {
  [Languages.RU]: string
  [Languages.UZ]: string
}

export const getCurrentTitle = (
  titleValue: string | IUzGetPageRenderResponseTextParam,
  lang: string = Languages.UZ,
) => {
  if (typeof titleValue === 'object') {
    return titleValue[lang as Languages.RU | Languages.UZ]
  }

  return titleValue
}
